import Utils from "assets/commonjs/tool";
import { toast } from "assets/commonjs/toast";
import { getStore,setStore } from "assets/commonjs/storage";
import strageList from '@/api/module/strageList'
import Router from '../../router/router'
import base from '@/api/base'

export const user = {
    companyId:1,
    userType:1,
    tradeUrl:process.env.VUE_APP_H5_TRADE,
    appUserInfo() {
        let appUserUrl = Utils.getUrlData();
        if (appUserUrl != null && appUserUrl != '') {
            if (appUserUrl.indexOf("noneheader") != -1) {
             return true
            }
        }
        return null;
      },
      goTrade(symbol){
        if (getStore('noneheader') == null || getStore('noneheader') == "" || getStore('noneheader') == undefined) {
          window.location.href = this.tradeUrl;
       } else {
          if (user.mechined() == 0) {
           //安卓
           window.uiObject.toProductChartPage(symbol);
         } else {
           // ios
           if(typeof (window.toProductChartPage) != "undefined"){
             //兼容旧版本
            window.toProductChartPage(symbol);
           }else{
            window.webkit.messageHandlers.toProductChartPage.postMessage(symbol)
           }
          
         }
       }
      },
      appGoTrade(symbol){
        if (user.mechined() == 0) {
          //安卓
          window.uiObject.toProductChartPage(symbol);
        } else if (window.toProductChartPage === "function"){
          window.toProductChartPage(symbol);
        } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.toProductChartPage){
          window.webkit.messageHandlers.toProductChartPage.postMessage(symbol);
        } else {
          console.warn("toProductChartPage function not found for iOS.");
        }
      },
      /**
       * 
       * @returns {0|1|-1}
       * - 0: android
       * - 1: ios
       * - -1: uknown
       */
      mechined: function () {
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
        if (isAndroid) return 0;
        if (isiOS) return 1;
        else return -1;
    },
    autoLogin(appString){
        let data ={
           customer:appString
        }
        //以下headers寫法2023/5/23和後端Ryan確認 (原寫法API在UAT環境下異常, 在PRD正常)
        const headers = {
          Origin: `${base.origin}`
        };
        strageList.autoLogin(data, {headers}).then( res =>{
          // alert("自动登录" + res.data)
           if(res.data == null || res.data == ""){
                  //mis后台为调用成功
                  toast("app账号和密码不符合要求");
                  return;
              }
              let msg = res.data.ch_msg[0];
              if(msg == null){
                return
              }
           let userIpinfo = Utils.userIpInfo()  
           user.getUserInfo(msg,'',userIpinfo)
              
              
        })
      },
     
      getUserInfo(userInfo,label,userIpInfo){
       
        let account = String(userInfo.account);
       
        if(account.startsWith('11')){
          this.userType = 2
        }else{
          this.userType = 1
        }
        let userStatus;
         if(userInfo.activeStatus > 0  || userInfo.activeStatus != ""){
          userStatus = 1
        }else if(userInfo.activeStatus == ""){
          userStatus = 0
        }
        let data = {
          account:userInfo.account,
          userStatus:userStatus,
          phone:userInfo.phone,
          userLevel:userInfo.userLevel,
          userName:userInfo.userName,
          email:userInfo.email,
          companyId:this.companyId,
          userType:this.userType,
          userSource:userIpInfo.userSource,
          userDevice:userIpInfo.userDevice,
          userDeviceDetail:userIpInfo.userDeviceDetail
        }
        strageList.loginInfo(data).then( res =>{
          if(res.data && res.data.code == 0 ){
            setStore('userInfoAll',JSON.stringify(res.data.result))
            if(label == "login"){
              Router.push({path:'/'});
            }
            // console.log("调用成功")
          }else{
            toast(res.data.message);
          }
        })
      },
}
export default user